import db from "../Db";
import { GetAllCimetierByPlan, GetCimetierById } from "./Cimetier";

var _ = require("lodash");

// Récupération des svg sur le plan du cimetiere passé en parametre
export async function GetSvgByNumcime(NUMCIME) {
  // Récupération des SVG pour un cimetiere
  async function GetSvgByCimetiere(NUMCIME) {
    return new Promise(function (resolve, reject) {
      if (!db.isOpen()) {
        db.open();
      }

      // filtre svg pour un cimetiere
      db.SVG.where("NUMCIME")
        .equals(NUMCIME)
        .toArray()
        .then((result) => {
          return resolve(result);
        });
    });
  }

  // récupération du cimetiere
  const cimetiere = await GetCimetierById(NUMCIME);
  let svgs = [];

  // récupération de tous les cimetieres du plan
  const cimetieres = await GetAllCimetierByPlan(cimetiere.NUMPLAN);

  // parcours des cimetieres
  for (let i = 0; i < cimetieres.length; i++) {
    const _cimetiere = cimetieres[i];

    // récupération des svg d'un cimetiere
    const svg = await GetSvgByCimetiere(_cimetiere.NUMCIME);

    svgs = _.concat(svgs, svg);
  }

  return svgs;
}

export function GetSvgByIdLieu(LICLEUNIK) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.SVG.where("LICLEUNIK")
      .equals(LICLEUNIK)
      .first()
      .then((result) => {
        return resolve(result);
      });
  });
}
